import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import PurchaseRight from "../Layouts/PurchaseRight";



export default function PurchaseHistory() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <PurchaseRight />

       </div>
      </div>


      <Feature />
      <Footer />
    </div>
  );
}

